import PropTypes from 'prop-types';
import React from 'react';
import AccountListTable from './AccountListTable';
import ClientListTable from './ClientListTable';

export default function AccountsTabContainer({
  showAccountId,
  showLatestTransfer,
  showRefreshButton,
  accountListMessage,
}) {
  return (
    <div>
      {!$tlf.flipperNewAdminViewClientTable && (
        <AccountListTable
          accountListMessage={accountListMessage}
          showAccountId={showAccountId}
          showLatestTransfer={showLatestTransfer}
          showRefreshButton={showRefreshButton}
        />
      )}
      {$tlf.flipperNewAdminViewClientTable && (
        <ClientListTable
          accountListMessage={accountListMessage}
          showAccountId={showAccountId}
          showLatestTransfer={showLatestTransfer}
        />
      )}
    </div>
  );
}

AccountsTabContainer.propTypes = {
  showAccountId: PropTypes.bool.isRequired,
  showLatestTransfer: PropTypes.bool.isRequired,
  showRefreshButton: PropTypes.bool.isRequired,
  accountListMessage: PropTypes.string,
};
